import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the DownloadModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-download-modal',
  templateUrl: 'download-modal.html',
})
export class DownloadModalPage {

	public downloadUrl: string;
	lang: string;
	downloadPlatform: string;
  message: string;
  title: string;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    let downloadUrl = this.navParams.get('downloadUrl');
    //let downloadUrl = 'https://api.picmasters.de/storage/u/sg43cf/pub/dl/mU4W1BLAafn0hrPCH4s40DAaaUOTX97IAzIjyOfRcEiGD1zPvp';
    let lang = this.navParams.get('lang');
    let downloadPlatform = this.navParams.get('downloadPlatform');

    
    //////

    this.lang = lang
    this.downloadUrl = downloadUrl;
    this.downloadPlatform = downloadPlatform; 

    this.message = 'Please click the download button.';
      this.title = "Download created";

    console.log("DOWNLOAD URL IN MODAL:", this.downloadUrl);

  }

    closeModal() {
        this.navCtrl.pop();
    }

}



// WEBPACK FOOTER //
// ./src/pages/download-modal/download-modal.ts